import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('bank-agencies', storeModule.createStoreModule('bank-agencies'))
